import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';

const UserForm = () => {
  const [userId, setUserId] = useState('');
  const [username, setUsername] = useState('');
  const [designation, setDesignation] = useState('');
  const [accessLevel, setAccessLevel] = useState(''); 
  const [email, setEmail] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [photo, setPhoto] = useState('');
  const [specialization, setSpecialization] = useState('');
  const [departmentCode, setDepartmentCode] = useState('');
  const [users, setUsers] = useState([]);
  const [isViewing, setIsViewing] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');  // For search functionality

  const handleCreate = () => {
    const userData = {
      userId,
      username,
      designation,
      accessLevel,
      email,
      contactNumber,
      photo,
      specialization,
      department: { deptId: departmentCode },
    };

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/users`, userData)
      .then(response => {
        alert('User created successfully');
        resetForm();
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          alert('User Already Exists'); // Display the error message from the backend
        } else {
          alert('Error creating the user!');
        }
      });
  };

  const handleDelete = () => {
    if (!userId.trim()) {
      alert('Please enter a User ID to delete.');
      return;
    }

    axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/users/${userId.trim()}`)
      .then(response => {
        alert(response.data);  // Display the success message from the backend
        resetForm();
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            alert('User not found.');
          } else {
            alert(error.response.data);  // Display any other error messages
          }
        } else {
          alert('Error deleting user. Please try again.');
        }
      });
  };

  const handleView = () => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users`)
      .then(response => {
        const usersWithStatus = response.data.map(user => ({
          ...user,
          activeStatus: user.active === "1" ? "1" : "0" // Show 1 if active, else 0
        }));
        setUsers(usersWithStatus);
        setIsViewing(!isViewing);
      })
      .catch(error => alert('Error fetching users. Please try again.'));
  };

  const handleEditFetch = () => {
    if (!userId.trim()) {
      alert('Please enter a User ID to edit.');
      return;
    }

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/${userId.trim()}`)
      .then(response => {
        const user = response.data;
        setUsername(user.username);
        setDesignation(user.designation);
        setAccessLevel(user.accessLevel);
        setEmail(user.email);
        setContactNumber(user.contactNumber);
        setPhoto(user.photo);
        setSpecialization(user.specialization);
        setDepartmentCode(user.department.deptId.toString());
        setIsEditing(true);
      })
      .catch(error => alert('Error fetching user details. Please try again.'));
  };

  const handleEditSave = () => {
    if (!isEditing) return;

    const updatedUserData = {
      userId,
      username,
      designation,
      accessLevel,
      email,
      contactNumber,
      photo,
      specialization,
      department: { deptId: departmentCode },
    };

    axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/users/${userId.trim()}`, updatedUserData)
      .then(response => {
        alert('User details updated successfully!');
        resetForm();
      })
      .catch(error => alert('Error updating user details. Please try again.'));
  };

  const resetForm = () => {
    setUserId('');
    setUsername('');
    setDesignation('');
    setAccessLevel('');
    setEmail('');
    setContactNumber('');
    setPhoto('');
    setSpecialization('');
    setDepartmentCode('');
    setIsEditing(false);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) fileInput.value = '';
  };

  const handleFileChange = (e) => {
    getBase64(e.target.files[0]);
  };

  const getBase64 = (file) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => setPhoto(reader.result);
    reader.onerror = error => console.log('Error', error);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredUsers = users.filter(user => {
    console.log(user.userId,user.username,user.email)
    return (
      user.userId.includes(searchTerm) ||
      user.username?user.username:"".toLowerCase().includes(searchTerm) ||
      user.email?user.email:"".toLowerCase().includes(searchTerm)
    );
  });

  // console.log(filteredUsers);
  

  return (
    <div className="container-fluid my-4">
      <div className="row">
        {/* Form container */}
        <div className="card p-4 col-md-8 mx-auto" style={{ maxWidth: '600px', height: '600px', marginTop: '55px' }}>
          <h2 className="text-center mb-4" style={{ fontSize: '30px', color: 'navy' }}>{isEditing ? 'Edit User' : 'Manage User'}</h2>

          {/* User ID, Username, and Designation input fields */}
          <div className="row mb-3">
            <div className="col-md-12">
              <label className="form-label">User ID</label>
              <input
                type="text"
                className="form-control"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                style={{ paddingLeft: '10px', paddingRight: '10px' }}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-12">
              <label className="form-label">Username</label>
              <input
                type="text"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={{ paddingLeft: '10px', paddingRight: '10px' }}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label">Designation</label>
              <input
                type="text"
                className="form-control"
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
                style={{ paddingLeft: '10px', paddingRight: '10px' }}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Access Level</label>
              <input
                type="text"
                className="form-control"
                value={accessLevel}
                onChange={(e) => setAccessLevel(e.target.value)}
              />
            </div>
          </div>

          {/* Other fields on the same row */}
          <div className="row mb-3">
            <div className="col-md-4">
              <label className="form-label">Email</label>
              <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Contact Number</label>
              <input type="text" className="form-control" value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Department Code</label>
              <input type="text" className="form-control" value={departmentCode} onChange={(e) => setDepartmentCode(e.target.value)} />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label">Photo</label>
              <input type="file" className="form-control" onChange={handleFileChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Specialization</label>
              <input type="text" className="form-control" value={specialization} onChange={(e) => setSpecialization(e.target.value)} />
            </div>
          </div>

          {/* Buttons with space between them */}
          <div className="d-flex justify-content-between gap-3">
            <button className="btn btn-primary w-100" style={{ backgroundColor: 'navy', color: 'white' }} onClick={handleCreate}>Create</button>
            <button className="btn btn-primary w-100" style={{ backgroundColor: 'navy', color: 'white' }} onClick={handleDelete}>Remove</button>
            <button className="btn btn-primary w-100" style={{ backgroundColor: 'navy', color: 'white' }} onClick={handleView}>
              {isViewing ? 'Hide Users' : 'View Users'}
            </button>
            <button className="btn btn-primary w-100" style={{ backgroundColor: 'navy', color: 'white' }} onClick={isEditing ? handleEditSave : handleEditFetch}>
              {isEditing ? 'Save Changes' : 'Edit'}
            </button>
          </div>
        </div>

        {/* User details table, shown only when isViewing is true */}
        {isViewing && (
          <div className="col-md-6 mt-4 mt-md-0">
            <h2 className="text-center mt-3" style={{ color: 'navy', fontSize: '30px' }}>Users</h2>
            {/* <input
                type="text"
                className="form-control mb-3"
                placeholder="Search by User ID, Username or Email"
                value={searchTerm}
                onChange={handleSearch}
                style={{ width: '100%', marginBottom: '15px' }}
              /> */}
            <div style={{ maxHeight: '500px', overflowY: 'auto' }} className='p-0'>
  <table className="table table-striped table-bordered table-hover rounded-5">
<thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 10 }}>
    <tr>
      <th className='bg-secondary'>User ID</th>
      <th className='bg-secondary'>Username</th>
      <th className='bg-secondary'>Designation</th>
      <th className='bg-secondary'>Access Level</th>
      <th className='bg-secondary'>Email</th>
      <th className='bg-secondary'>Contact Number</th>
      <th className='bg-secondary'>Department Code</th>
      <th className='bg-secondary'>Photo URL</th>
      <th className='bg-secondary'>Specialization</th>
      <th className='bg-secondary'>Active</th>
    </tr>
  </thead>
  <tbody>
    {filteredUsers.map(user => (
      <tr key={user.userId}>
        <td>{user.userId}</td>
        <td>{user.username}</td>
        <td>{user.designation}</td>
        <td>{user.accessLevel}</td>
        <td>{user.email}</td>
        <td>{user.contactNumber}</td>
        <td>{user.department.deptId}</td>
        <td><img src={user.photo} alt="User Photo" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /></td>
        <td>{user.specialization}</td>
        <td>{user.activeStatus === "1" ? "Active" : "Inactive"}</td>
      </tr>
    ))}
  </tbody>
</table>

            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserForm;
